var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo } from 'react';
import { KeySelectionModalContext, } from 'root/src/client/v2/drop/features/KeySelectionModal/hooks/useKeySelectionModal';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { InitialProductSelectField, KeySelectionModalHeading, } from 'root/src/client/v2/drop/features/KeySelectionModal/components/KeySelectionModal';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import Icon from 'root/src/client/web/base/Icon';
import DareDropIcon from 'root/src/client/public/icons/DareDropIcon';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useUserDropEventLandingShortUrlQuery } from 'root/src/client/v2/drop/hooks/useDropEventLandingShortUrlQuery';
import { InitialProductDisplayModal, } from 'root/src/client/v2/drop/features/KeySelectionModal/components/InitialProductDisplayModal';
import { colorsNew } from 'root/src/client/web/commonStyles';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import toast from 'react-hot-toast';
export const ReclaimKeySelectionModal = memo((props) => {
    const { drop } = props;
    const { form, onSubmit } = useReclaimKeySelectionModal(props);
    return (<ModalLayout className="sm:min-w-[600px]">
			{/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
			<KeySelectionModalContext.Provider value={{ dropEvent: drop }}>
				<FormProvider {...form}>
					<form onSubmit={onSubmit}>
						<div className="flex flex-col justify-center items-center gap-8">
							<KeySelectionModalHeading />
							<InitialProductSelectField />
							<DeliveryRateInfo />
							<Submit />
						</div>
					</form>
				</FormProvider>
			</KeySelectionModalContext.Provider>
		</ModalLayout>);
});
const DeliveryRateInfo = () => {
    return (<div className="flex flex-col justify-center items-center gap-2">
			<p className="text-center text-sm font-medium max-w-fit" style={{ color: colorsNew.green }}>
				Delivering without key increases delivery rate!
			</p>
		</div>);
};
const Submit = () => {
    const form = useFormContext();
    const isLoading = form.formState.isSubmitting;
    return (<ButtonNew disabled={isLoading} className="flex justify-center items-center gap-1 px-2 py-1.5" type="submit">
			{isLoading ? <LoadingCircles width={33} height={33}/> : <Icon icon={DareDropIcon} size={33}/>}
			<span className="font-bold uppercase text-xl">
				Reclaim Reward
			</span>
		</ButtonNew>);
};
export const reclaimKeySelectionFormSchema = z.object({
    productId: z.string(),
});
const useReclaimKeySelectionModal = ({ drop, onSuccess }) => {
    const form = useForm({
        resolver: zodResolver(reclaimKeySelectionFormSchema),
        defaultValues: getDefaultValues(drop),
    });
    const modal = useModal();
    const reclaimRewardMutation = trpc.rewards.reclaimCreatorInitialReward.useMutation();
    const userLandingShortUrlQuery = useUserDropEventLandingShortUrlQuery(drop.id, {
        enabled: false,
    });
    const onSubmit = form.handleSubmit((formData) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const products = yield reclaimRewardMutation.mutateAsync({ dropId: drop.id, productId: formData.productId });
            const shortUrlQuery = yield userLandingShortUrlQuery.refetch();
            if (shortUrlQuery.isError) {
                throw new Error(shortUrlQuery.error.message);
            }
            modal.show(<InitialProductDisplayModal dropEvent={drop} shortUrl={shortUrlQuery.data} products={products}/>, {
                isCloseable: false,
            });
            if (onSuccess) {
                onSuccess();
            }
        }
        catch (err) {
            console.error(err);
            const message = (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : 'Something went wrong!';
            toast.error(message);
        }
    }));
    return {
        form,
        onSubmit,
    };
};
const getDefaultValues = (drop) => {
    var _a, _b;
    const initialProduct = (_a = drop.initialProduct) !== null && _a !== void 0 ? _a : [];
    const isSingleProduct = initialProduct.length === 1;
    if (!isSingleProduct) {
        return undefined;
    }
    return {
        productId: (_b = initialProduct.at(0)) === null || _b === void 0 ? void 0 : _b.id,
    };
};
